if (!customElements.get('moyn-showcase')) {
  customElements.define('moyn-showcase', class extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-showcase-tab]'));
      this.panels = Array.from(this.querySelectorAll('.moyn-showcase__panel'));
      if (!this.tabs.length) return;
      this.select = (index, focus = false) => {
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          this.panels[i].hidden = i !== index;
        });
        if (focus) this.tabs[index].focus({ preventScroll: true });
      };
      this.onClick = event => {
        const tab = event.target.closest('[data-showcase-tab]');
        if (tab && this.contains(tab)) this.select(this.tabs.indexOf(tab));
      };
      this.onKeyDown = event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next !== undefined) {
          event.preventDefault();
          this.select(next, true);
        }
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeyDown);
      this.classList.add('is-enhanced');
      this.select(0);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeyDown);
    }
  });
}
